import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { Button, Form, Container, Alert } from 'react-bootstrap';
import '../css/profile.css'

export default function ProfileForm() {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    displayName: '',
    age: '',
    bio: '',
    website: '',
    clan: 0,
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', variant: '' });

  const clanInfo = [
    { title: 'Elige un clan', description: 'Desc', imageURL: '' },
    { title: 'Comiehchúcuaro',  
      description: '<p><b>La Calma que Sana y Transforma</b><br>Elegir el Comiehchúcuaro es conectar con un poder único: el de sanar y proteger la vida que te rodea. No eres de los que buscan pelea, pero cuando tu comunidad, tus amigos o tus ideales están amenazados, surges con la fuerza serena de la tierra misma. Eres ese compañero leal en quien todos confían, el que organiza el trabajo en equipo y siempre piensa en el bien colectivo. Tu fuerza no es para dominar, sino para custodiar; tu coraje no es para destruir, sino para construir y sanar. Inspirado por el dios purépecha del inframundo, asociado a la renovación de la tierra y los ciclos de la naturaleza, tu esencia es la del guardián resiliente. Entiendes que de las dificultades más profundas (como el inframundo) puede brotar un nuevo crecimiento, y que la verdadera fortaleza se mide por la capacidad de proteger y hacer florecer tu entorno.</p><p><i><b>Tus dones esenciales:</b> Protector Compasivo, Resiliencia Sanadora, Fuerza Serena</i></p>',
      imageURL: '' 
    },
    { title: 'Mictlán', 
      description: '<p><b>El Guerrero que Sana la Tierra</b><br>Elegir Mictlán es entender que en la vida no todo es ruido y luces; a veces, el poder más real está en la quietud. Eres esa persona que no necesita ser el centro de atención, pero cuya presencia se extraña cuando no está. Eres el amigo que escucha sin juzgar, el que da el consejo justo en el momento difícil y el que encuentra fuerza en la honestidad, aunque duela. Tu valor no está en gritar más fuerte, sino en saber cuándo un silencio vale más que mil palabras. Entiendes que terminar una etapa, superar un problema o dejar ir lo que ya no sirve, no es un fracaso, sino un acto de valentía para renacer como una versión más fuerte y sabia de ti mismo. Eres el faro tranquilo en la tormenta, la calma que todo lo sana.</p><p><i><b>Tus poderes secretos:</b> Sabiduría Emocional, Resiliencia Silenciosa, Honestidad Radical</i></p>',
      imageURL: '' 
    },
    { title: 'Xibalba', 
      description: '<p><b>Los que no le huyen al reto</b><br>Elegir Xibalbá es para los que no le huyen a lo difícil, sino que lo ven como su oportunidad de brillar. Eres de esos que, cuando todos entran en pánico, mantienen la calma y analizan cada movimiento. Tu mente es tu arma principal: eres estratégico, ingenioso y te creces bajo presión. No sigues modas, marcas tu propio camino con confianza, porque sabes que los obstáculos no son para detenerte, sino para demostrar de qué estás hecho. Eres quien encuentra la salida en el laberinto, el jugador maestro que convierte el miedo en su ventaja. Aquí no se trata de ser el más fuerte, sino el más inteligente y resiliente. Eres la prueba de que en la oscuridad es donde mejor se ve la luz.</p><p><i><b>Tus poderes secretos:</b> Mente Estratégica, Resiliencia Pura, Confianza Interna</i></p>', 
      imageURL: '' 
    },
    { title: 'Echéndaro', 
      description: '<p><b>El Guardián de la Alegría y la Tradición</b><br>Elegir el clan Ehéndaro significa que tu espíritu es como el sol de la mañana: iluminas el ambiente con alegría contagiosa y eres el corazón de tu grupo. Eres esa persona que siempre está buscando una razón para celebrar, que valora la amistad, la música y los momentos que unen a las personas. Para ti, la tradición no es algo aburrido, sino la esencia de tu identidad; te enorgullece conocer tus raíces y compartir con los demás la riqueza de tu cultura. Eres el guardián de la memoria colectiva, el que mantiene viva la llama de la fiesta, el baile y la comunidad. Tu fuerza no viene de la batalla, sino de la capacidad de sanar el alma con alegría y unir a los demás a través del respeto y la celebración de la vida.</p><p><i><b>Tus dones únicos:</b> Alegría Contagiosa, Conexión con tus Raíces, Guardian de la Memoria</i></p>', 
      imageURL: '' 
    }
  ];

  // Assign class to #profile-main-bg based on clan value
  useEffect(() => {
    const bg = document.getElementById('profile-main-bg');
    if (bg) {
      // Remove all previous clan classes
      bg.classList.remove('clan-0', 'clan-1', 'clan-2', 'clan-3', 'clan-4');
      // Add the current clan class
      bg.classList.add(`clan-${formData.clan}`);
    }
  }, [formData.clan]);

  useEffect(() => {
    const fetchUserData = async () => {
      if (currentUser) {
        try {
          const docRef = doc(db, 'users', currentUser.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            setFormData({
              displayName: data.displayName || '',
              age: data.age || '',
              bio: data.bio || '',
              website: data.website || '',
              clan: typeof data.clan !== 'undefined' ? data.clan : 0,
            });
          } else {
            setFormData({
              displayName: '',
              age: '',
              bio: '',
              website: '',
              clan: 0,
            });
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    };

    fetchUserData();
  }, [currentUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'clan' ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await setDoc(doc(db, 'users', currentUser.uid), {
        ...formData,
        lastUpdated: new Date()
      });
      setMessage({ text: '¡Perfil guardado con éxito!', variant: 'success' });
    } catch (error) {
      setMessage({ text: 'Error al guardar tu perfil: ' + error.message, variant: 'danger' });
      console.error("Error writing document: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id='profile-main-bg' className='clan-0'>
      <Container className="" style={{ paddingTop: '150px'}}>
        <div className="row">
          <div className="col-md-6">
            <h2>Tu perfil</h2>
            {message.text && <Alert variant={message.variant}>{message.text}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Nombre para mostrar</Form.Label>
                <Form.Control
                  type="text"
                  name="displayName"
                  value={formData.displayName}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Edad</Form.Label>
                <Form.Control
                  type="number"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                />
                <small className="form-text text-muted">
                  No mostraremos tu edad en el sitio, es solo para fines de personalización.
                </small>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Clan</Form.Label>
                <Form.Select
                  name="clan"
                  value={formData.clan}
                  onChange={handleChange}
                >
                  <option value={0}>Ninguno</option>
                  <option value={4}>Echéndaro</option>
                  <option value={1}>Comiehchúcuaro</option>
                  <option value={2}>Mictlán</option>
                  <option value={3}>Xibalba</option>
                </Form.Select>
              </Form.Group>

              <div className="d-flex justify-content-end align-items-center">
                <small>¡No olvides guardar los cambios!</small>
                <Button className='Galindo' type="submit" disabled={loading} style={{ marginLeft: '10px' }}>
                  {loading ? 'Guardando...' : 'Guardar Cambios'}
                </Button>
              </div>

              {formData.clan !== 0 && (
                <div id="clanLoad" className="">
                  <h2>{clanInfo[formData.clan]?.title}</h2>
                  <div className="description" style={{fontSize: 'small'}} dangerouslySetInnerHTML={{ __html: clanInfo[formData.clan]?.description }} />
                  {clanInfo[formData.clan]?.imageURL && (
                    <img
                      src={clanInfo[formData.clan].imageURL}
                      alt={clanInfo[formData.clan].title}
                      style={{ maxWidth: '100%', marginTop: '1rem' }}
                    />
                  )}
                </div>
              )}
            </Form>
          </div>
          <div className="col-md-6">
            <div style={{minHeight:'600px'}}></div>
          </div>
        </div>
      </Container>
    </div>
  );
}